<template>
    <v-container fluid>
        <v-list>
            <v-subheader>Recent Activity</v-subheader>
            <v-list-item class="tile" v-for="(item, i) in activityList" :key="i">
                <activity-item 
                :activity="item"
                @viewTreatment="viewTreatment"
                @viewComment="viewComment">
                </activity-item>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
import ActivityItem from './Activity.vue';

export default {
    data () {
        return {
            activityList: []
        }
    },
    components: {
        ActivityItem
    },
    props: {
        userDb: Object
    },
    computed: {
    },
    mounted(){
        //this.activityList = this.userDb.activity;
    },
    watch: {
        userDb: { 
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                if (val !== null){
                    this.activityList = val.activity;
                }
            }
        }
    },
    methods: {
        viewTreatment(id){
            //This will call a dialog to view the treatment
            console.log("Viewing Treatment" + id); //eslint-disable-line
        },
        viewComment(id){
            //This will call a dialog to view the comment
            console.log("Viewing Comment" + id); //eslint-disable-line
        }
    }
}
</script>

<style scoped>
  .tile {
    margin: 5px;
    border-radius: 4px;
    /* Color = cyan-lighten-5 */
    background: #e0f7fa; 
  }
</style>